import * as THREE from 'three'
import { useEffect, useRef, useState } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import PanningCameraBehaviour from './PanningCameraBehaviour'

export type PanHandlerProps = {
  flipY?: boolean
  flipX?: boolean
  dragSensitivity?: number,
  enabled?: boolean,
  children?: JSX.Element | JSX.Element[] | null
}

export default function PanHandler (props: PanHandlerProps) {
  const yRotationRef = useRef<THREE.Object3D>()
  const xRotationRef = useRef<THREE.Object3D>()
  const { gl } = useThree()
  const [panningBehaviour, setPanningBehaviour] = useState<PanningCameraBehaviour>()

  if (gl.xr.isPresenting) return null

  // This triggers on every canvas frame
  useFrame((_state, _delta) => {
    if (panningBehaviour !== null) {
      if (!props.enabled ?? true) return

      panningBehaviour?.onUpdate(_delta)
    }
  })

  // This is triggered when a prop changes
  useEffect(() => {
    const pan = new PanningCameraBehaviour({
      canvas: gl.domElement,
      yAxisRotationTarget: (yRotationRef.current ?? new THREE.Object3D()),
      xAxisRotationTarget: (xRotationRef.current ?? new THREE.Object3D()),
      ...props
    })

    setPanningBehaviour(pan)
    pan.enable()

    return () => {
      panningBehaviour?.dispose()
    }
  }, [])

  useEffect(() => {
    if (!props.enabled ?? true) panningBehaviour?.deactivate()
    else panningBehaviour?.activate()
  }, [props.enabled])

  return (
    <object3D ref={yRotationRef}>
      <object3D ref={xRotationRef}>
        {props.children}
      </object3D>
    </object3D>
  )
}
